import * as React from 'react';
import {
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  Typography,
  Grid,
  Paper,
  Avatar,
  InputAdornment,
  Tooltip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Autocomplete,
  CircularProgress
} from '@mui/material';
import {
  Business as BusinessIcon,
  LocationOn as LocationIcon,
  Contacts as ContactsIcon,
  Receipt as ReceiptIcon,
  Settings as SettingsIcon,
  Image as ImageIcon,
  ExpandMore as ExpandMoreIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  CloudUpload as CloudUploadIcon
} from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router';
import axios from 'axios';
import { useSnackbar } from 'src/components/snackbar/useSnackbar';
import { get, post, put } from 'src/services/httpClient.service';
import { authenticationService } from 'src/services/authentication.service';

const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

const EditFranchisee = () => {

  const { vendorId, franchiseId } = authenticationService.getVendorFranchiseIds();

  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { id } = useParams();
  const [franchisedata, setFranchisedata] = React.useState<any>();
  const [companies, setCompanies] = React.useState([]);
  const [states, setStates] = React.useState([]);
  const [cities, setCities] = React.useState([]);
  const [priceLists, setPriceLists] = React.useState([]);
  const [loadingCities, setLoadingCities] = React.useState(false);
  const [areaList, setAreaList] = React.useState([]);
  const [selectedBillingAreaId, setSelectedBillingAreaId] = React.useState('');
  const [existingLogo, setExistingLogo] = React.useState('');

  const [loadingPriceLists, setLoadingPriceLists] = React.useState(false); // Add loading state
  const [zonelist, setZoneList] = React.useState([])
  const [operatorsList, setOperatorList] = React.useState<any[]>([]);

  const [billingTaxTypes, setBillingTaxTypes] = React.useState([]);

  const billingtaxtype = async () => {
  try {
    const res = await get(
      `${API_BASE_URL}/api/billing-tax-type/vendor/${vendorId}/getAll`
    );

    if (res?.success && res?.data) {
      setBillingTaxTypes(res.data);
    }
  } catch (error) {
    console.error("Error fetching billing tax types", error);
  }
};
  
  const [formData, setFormData] = React.useState({
    // Basic Information
    name: '',
    companyId: '',
    company: '',


    parent: '',
    franchiseeCode: '',
    status: true,
    openingAmount: '',
    openingType: 'Debit',
    franchiseeType: '',
    description: '',
    billNotes: '',
    slogan: '',

    subscriptionExtendedDays: '',

    // Address Information
    addressLine1: '',
    addressLine2: '',
    //addressLine3: '',
    //country: '',
    //state: '',
    //zone: '',
    // city: '',
    area: '',
    postCode: '',

    // Contact Information
    mobileNo: '',
    phoneNo: '',
    email: '',

    // Tax Information
    serviceTaxNo: '',
    entertainmentTaxNo: '',
    gstNo: '',
    billingTaxId: '',
    panNo: '',
    aadharNo: '',

    // Financial Information
    creditLimit: '',
    onlineRechargeMinAmount: '',
    businessName: '',

    // Franchisee Settings
    priceListId: '',
    disablePostPaidCustomerCreation: false,
    isApplyFranchiseeInfoInBill: false,
    isManageUserWallet: false,
    isManageLCOWallet: false, 
    disableSubTypeDay: false,
    disableSubTypeOption: false,

    // Logo
    companyLogo: null,
    zone: '',
    areaId: '',
    areaName: ''
  });

  React.useEffect(() => {
    fetchCompanies();
    fetchAreas(); // Fetch areas first
    billingtaxtype();
  }, []);

  // Fetch company list
  const fetchCompanies = async () => {
    try {
      const response = await get(`${API_BASE_URL}/api/company/vendor/${vendorId}/fetchAll`);
      if (Array.isArray(response)) {
        setCompanies(response);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
      showSnackbar("Failed to load companies", "error");
    }
  };

  // Fetch states
  // const fetchStates = async () => {
  //   try {
  //     const response = await get(`${API_BASE_URL}/states`);
  //     if (Array.isArray(response)) {
  //       setStates(response);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching states:", error);
  //   }
  // };

  // // Fetch cities dynamically based on state
  // const fetchCities = async (stateName) => {
  //   if (!stateName) {
  //     setCities([]);
  //     return;
  //   }

  //   setLoadingCities(true);
  //   try {
  //     const response = await get(`${API_BASE_URL}/cities?stateName=${encodeURIComponent(stateName)}`);
  //     if (Array.isArray(response)) {
  //       setCities(response);
  //     } else if (Array.isArray(response.data)) {
  //       setCities(response.data);
  //     } else {
  //       setCities([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching cities:", error);
  //   } finally {
  //     setLoadingCities(false);
  //   }
  // };

  React.useEffect(() => {
    // Only get franchise data after areas are loaded
    if (areaList.length > 0 && id) {
      getFranchiseData();
    }
  }, [id, areaList.length]); // Add dependency on areaList


  const fetchAreas = async () => {
    try {
      const response = await get(
        `${API_BASE_URL}/api/miscellaneous/area/vendor/${vendorId}/findAll`
      );
      if (response) setAreaList(response?.data);
      console.log('city', response?.data)
    } catch (error) {
      console.error("Error fetching areas", error);
    }
  };

  React.useEffect(() => {
    fetchAreas();
    //handlezonelist();
    getOperatorList();
  }, []);

  const getOperatorList = async () => {
      try {
        //setLoading(true);
  
        const response = await get(`${API_BASE_URL}/api/operators/vendor/${vendorId}/getOperatorAccountTypeList`, {params: {accountTypes: "OWNER,DISTRIBUTOR"}});
        const data = Array.isArray(response?.data) ? response.data : [];
        setOperatorList(data);

      } catch (error: any) {
        if (error?.response?.status === 404) {
          setOperatorList([]);
        } else {
          showSnackbar(
            error?.message || "Failed to fetch operators",
            "error"
          );
        }
      } finally {
        //setLoading(false);
      }
    };

    

  const handlezonelist = async () => {

    try {

      const response = await get(`${API_BASE_URL}/api/miscellaneous/zone/vendor/${vendorId}/findAll`)
      console.log('zone', response?.data)
      setZoneList(response?.data)

    } catch (error) {
      console.log("zonelist", error)
    }

  }

  const getFranchiseData = async () => {
    try {
      const franchiseeData = await get(`${API_BASE_URL}/api/franchisees/vendor/${vendorId}/getFranchiseeById`, { params: { id: id } });
      const franchise = franchiseeData?.data;
      console.log('franchisegetdata:', franchise);
      setFranchisedata(franchise);
      setExistingLogo(franchise?.logoFileName);
      // Update formData when franchise data is loaded
      setFormData(prev => ({
        ...prev,
        name: franchise?.name || '',
        companyId: franchise?.companyId || '',
        company: franchise?.company || '',
        parent: franchise?.parent || '',
        franchiseeCode: franchise?.franchiseeCode || '',
        status: franchise?.status !== undefined ? franchise.status : true,
        openingAmount: franchise?.openingAmount || '',
        openingType: franchise?.openingType || '',
        franchiseeType: franchise?.franchiseeType || '',
        description: franchise?.description || '',
        billNotes: franchise?.billNotes || '',
        billingTaxId: franchise?.billingTaxId || '',
        subscriptionExtendedDays: franchise?.subscriptionExtendedDays || '',
        slogan: franchise?.slogan || '',
        zone: franchise?.zone || '',
        addressLine1: franchise?.addressLine1 || '',
        addressLine2: franchise?.addressLine2 || '',
        // addressLine3: franchise?.addressLine3 || '',
        //country: franchise?.country || '',
        //state: franchise?.state || '',
        //zone: franchise?.zone || '',
        //city: franchise?.city || '',
        area: franchise?.area || '',
        postCode: franchise?.postCode || '',
        mobileNo: franchise?.mobileNo || '',
        phoneNo: franchise?.phoneNo || '',
        email: franchise?.email || '',
        serviceTaxNo: franchise?.serviceTaxNo || '',
        entertainmentTaxNo: franchise?.entertainmentTaxNo || '',
        gstNo: franchise?.gstNo || '',
        panNo: franchise?.panNo || '',
        aadharNo: franchise?.aadharNo || '',
        creditLimit: franchise?.creditLimit || '',
        onlineRechargeMinAmount: franchise?.onlineRechargeMinAmount || '',
        businessName: franchise?.businessName || '',
        disablePostPaidCustomerCreation: franchise?.disablePostPaidCustomerCreation || false,
        isApplyFranchiseeInfoInBill: franchise?.isApplyFranchiseeInfoInBill || false,
        isManageUserWallet: franchise?.isManageUserWallet || false,
        isManageLCOWallet: franchise?.isManageLCOWallet || false, 
        disableSubTypeDay: franchise?.disableSubTypeDay || false,
        disableSubTypeOption: franchise?.disableSubTypeOption || false,
        companyLogo: franchise?.companyLogo || '',
        vendorId: franchise?.vendorId || '',
        franchiseId: franchise?.franchiseId || '',
        areaId: franchise?.areaId || '',
        priceListId: franchise?.priceListId || '',
      }));
    } catch (error) {
      console.error('Error fetching franchise data:', error);
    }
  };

  const [expanded, setExpanded] = React.useState('basic');

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // Fetch price lists function

  const fetchPriceListByVendor = async () => {
      try {
        const response = await get(
          `${API_BASE_URL}/api/area-wise-price-list/vendor/${vendorId}/getPriceListsByVendorId`
        );
  
        console.log("Price List API Response:", response);
        if (response?.data && Array.isArray(response.data)) {
          setPriceLists(response.data);
        } else {
          setPriceLists([]);
        }
  
      } catch (error) {
        console.error("Error fetching price list:", error);
        setPriceLists([]);
      }
    };
    React.useEffect(() => {
      fetchPriceListByVendor();
    }, []);

  // const fetchPriceListByCity = async (areaId) => {
  //   if (!areaId) {
  //     setPriceLists([]);
  //     return;
  //   }

  //   setLoadingPriceLists(true); // Start loading
  //   try {
  //     const response = await get(
  //       `${API_BASE_URL}/api/area-wise-price-list/vendor/${vendorId}/searchByAreaId?areaId=${areaId}`
  //     );

  //     console.log("Price List API Response:", response);

  //     if (response?.data && Array.isArray(response.data)) {
  //       setPriceLists(response.data);
  //     } else {
  //       setPriceLists([]);
  //     }

  //   } catch (error) {
  //     console.error("Error fetching price list:", error);
  //     setPriceLists([]);
  //   } finally {
  //     setLoadingPriceLists(false); // End loading
  //   }
  // };
  // Add this useEffect to set priceListId after price lists are loaded
  React.useEffect(() => {
    if (priceLists.length > 0 && formData.priceListId) {
      // Check if the current priceListId exists in the fetched priceLists
      const priceListExists = priceLists.some(p => p.id === formData.priceListId);

      if (!priceListExists) {
        // If the saved priceListId doesn't exist in current lists, clear it
        setFormData(prev => ({
          ...prev,
          priceListId: ''
        }));
      }
    }
  }, [priceLists, formData.priceListId]);

  React.useEffect(() => {
    // if (formData.areaId != null && formData.areaId != undefined && formData.areaId != "") {
    //   fetchPriceListByCity(formData.areaId);
    // }
  }, [formData.areaId]);
  const handleChange = (e) => {
    const { name, value } = e.target;

    // if (name === "areaName") {
    //   fetchPriceListByCity(value);
    // }

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };


  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  /* const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prev => ({
          ...prev,
          logo: reader.result
        }));
      };
      reader.readAsDataURL(file);
    }
  }; */

  const handleFileChange = (e) => {
  const file = e.target.files[0];

  if (file) {
    setFormData(prev => ({
      ...prev,
      companyLogo: file
    }));

    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData(prev => ({
        ...prev,
        logoPreview: reader.result
      }));
    };

    reader.readAsDataURL(file);
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    //console.log('Updated Franchisee Data:', formData);

    const payload = new FormData();

// Object.keys(formData).forEach(key => {
//   payload.append(key, formData[key]);
// });
Object.keys(formData).forEach(key => {
  if (formData[key] !== null && formData[key] !== undefined && formData[key] !== '') {
    payload.append(key, formData[key]);
  }
});

    try {
      const response = await put(
        `${API_BASE_URL}/api/franchisees/${id}`,
        payload
      );

      console.log('Update successful:', response);
      showSnackbar('Franchisee updated successfully', 'success')
      navigate('/franchise');

    } catch (error) {
      showSnackbar(error?.response?.data?.message, 'error')
      //console.error('Error updating franchisee:', error?.response?.data?.message);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ padding: 3 }}>
      <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          {formData.companyLogo ? (
            <Avatar
              src={typeof formData.companyLogo === 'string' && !formData.companyLogo.startsWith('data:') ?
                `/${formData.companyLogo}` : formData.companyLogo}
              sx={{ width: 80, height: 80, mr: 3 }}
            />
          ) : (
            <Avatar sx={{ width: 80, height: 80, mr: 3, bgcolor: 'primary.main' }}>
              <BusinessIcon fontSize="large" />
            </Avatar>
          )}
          <Box>
            <Typography variant="h5" component="div">
              {id}
            </Typography>
            <Typography variant="h5" component="div">
              {formData.name || 'New Franchisee'}
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              {formData.franchiseeCode || 'FR-XXXXXX'}
            </Typography>
            <Typography variant="body2" color={formData.status ? 'success.main' : 'error.main'}>
              {formData.status ? 'Active' : 'Inactive'}
            </Typography>
          </Box>
        </Box>

        <Accordion expanded={expanded === 'basic'} onChange={handleAccordionChange('basic')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <BusinessIcon color="primary" sx={{ mr: 2 }} />
              <Typography variant="h6">Basic Information</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  required
                  fullWidth
                  label="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <BusinessIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <InputLabel>Company</InputLabel>
                  <Select
                    name="companyId"
                    value={formData.companyId}
                    label="Company"
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const selectedCompany = companies.find((c) => c.id === selectedId);
                      setFormData((prev) => ({
                        ...prev,
                        companyId: selectedId,
                        company: selectedCompany ? selectedCompany.companyName : "",
                      }));
                    }}
                  >
                    <MenuItem value="">Select Company</MenuItem>
                    {companies.map((company) => (
                      <MenuItem key={company.id} value={company.id}>
                        {company.companyName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>


              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <InputLabel>Parent</InputLabel>
                  <Select
                    name="parent"
                    value={formData.parent}
                    label="Parent"
                    onChange={handleChange}
                  >
                    <MenuItem value="">Select Parent</MenuItem>
                    {operatorsList.map((operator) => (
                      <MenuItem key={operator.id} value={operator.id}>
                        {operator.operatorName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Parent"
                  name="parent"
                  value={formData.parent}
                  onChange={handleChange}
                />
              </Grid> */}

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  required
                  fullWidth
                  label="Franchisee Code"
                  name="franchiseeCode"
                  value={formData.franchiseeCode}
                  onChange={handleChange}
                />
              </Grid>



              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Opening Amount"
                  name="openingAmount"
                  type="number"
                  value={formData.openingAmount}
                  onChange={handleChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        ₹
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              {/* <Grid item xs={12} sm={6} md={3}>
                        <FormControl fullWidth>
                          <InputLabel>Franchisee Type</InputLabel>
                          <Select
                            name="franchiseeType"
                            value={formData.franchiseeType}
                            label="Franchisee Type"
                            onChange={handleChange}
                          >
                            <MenuItem value="">Search Franchisee Type</MenuItem>
                            {
                              operatorsList.map((distributer) => (
                                <MenuItem key={distributer.id} value={distributer.id}>
                                  {distributer.email}
                                </MenuItem>
                              ))
                            }
              
                          </Select>
                        </FormControl>
                      </Grid> */}

              {/* <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <InputLabel>Franchisee Type</InputLabel>
                  <Select
                    name="franchiseeType"
                    value={formData.franchiseeType}
                    label="Franchisee Type"
                    onChange={handleChange}
                  >
                    <MenuItem value="">Search Franchisee Type</MenuItem>
                    <MenuItem value="lco">Lco</MenuItem>
                    <MenuItem value="distributer">Distributer</MenuItem>
                  </Select>
                </FormControl>
              </Grid> */}

              <Grid item xs={12} sm={6} md={4}>
                <FormControlLabel
                  control={
                    <Tooltip title={formData.status ? 'Active' : 'Inactive'}>
                      <Switch
                        name="status"
                        checked={formData.status}
                        onChange={handleSwitchChange}
                        color="primary"
                      />
                    </Tooltip>
                  }
                  label="Status"
                  labelPlacement="start"
                  sx={{ justifyContent: 'space-between', ml: 0 }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Description"
                  name="description"
                  multiline
                  rows={3}
                  value={formData.description}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Franchisee Bill Notes"
                  name="billNotes"
                  multiline
                  rows={3}
                  value={formData.billNotes}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Slogan"
                  name="slogan"
                  value={formData.slogan}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion expanded={expanded === 'address'} onChange={handleAccordionChange('address')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <LocationIcon color="primary" sx={{ mr: 2 }} />
              <Typography variant="h6">Address Information</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Address Line"
                  name="addressLine1"
                  value={formData.addressLine1}
                  onChange={handleChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LocationIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Landmark/Village"
                  name="addressLine2"
                  value={formData.addressLine2}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={6}>
                <Autocomplete
                  options={areaList}
                  loading={!areaList.length}

                  // This is the key fix - ensure we have a proper value object
                  value={(() => {
                    if (!formData.areaId) return null;
                    const foundArea = areaList.find(
                      (a) => String(a.id) === String(formData.areaId)
                    );
                    return foundArea || null;
                  })()}

                  getOptionLabel={(option) =>
                    `${option.name} / ${option.districtName} / ${option.cityName} / ${option.stateName} / ${option.countryName} / ${option.zipCode}`
                  }

                  isOptionEqualToValue={(option, value) => {
                    // Compare both by ID to ensure proper equality check
                    if (!option || !value) return false;
                    return String(option.id) === String(value.id);
                  }}

                  // Update your Autocomplete onChange handler
                  onChange={(_, newValue) => {
                    if (newValue) {
                      setFormData((prev) => ({
                        ...prev,
                        areaId: newValue.id,
                        areaName: newValue.cityName || newValue.name || '',
                        priceListId: '' // Reset priceListId when area changes
                      }));
                      // Fetch price lists for the selected area
                      //fetchPriceListByCity(newValue.id);
                    } else {
                      setFormData((prev) => ({
                        ...prev,
                        areaId: '',
                        areaName: '',
                        priceListId: '' // Reset priceListId
                      }));
                      setPriceLists([]);
                    }
                  }}

                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Area (City)"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {!areaList.length && <CircularProgress size={18} />}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>

              {/* <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Address Line 3"
                  name="addressLine3"
                  value={formData.addressLine3}
                  onChange={handleChange}
                />
              </Grid> */}

              {/* <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <InputLabel>Country</InputLabel>
                  <Select
                    name="country"
                    value={formData.country}
                    label="Country"
                    onChange={handleChange}
                  >
                    <MenuItem value="">Select Country</MenuItem>
                    <MenuItem value="India">India</MenuItem>
                  </Select>
                </FormControl>
              </Grid> */}

              {/*  <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <InputLabel>Zone</InputLabel>
                  <Select
                    name="zone"
                    value={formData.zone}
                    label="Zone"
                    onChange={handleChange}
                  >
                    <MenuItem value="">Select Zone</MenuItem>
                    <MenuItem value="North">North</MenuItem>
                    <MenuItem value="South">South</MenuItem>
                    <MenuItem value="East">East</MenuItem>
                    <MenuItem value="West">West</MenuItem>
                    <MenuItem value="Central">Central</MenuItem>
                    <MenuItem value="North-East">North-East</MenuItem>
                    <MenuItem value="North-West">North-West</MenuItem>
                    <MenuItem value="South-East">South-East</MenuItem>
                    <MenuItem value="South-West">South-West</MenuItem>
                  </Select>
                </FormControl>
              </Grid> */}


              {/* <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth >
                  <InputLabel>Zone</InputLabel>
                  <Select
                    name="zone"
                    value={formData.zone}
                    label="Zone"
                    onChange={handleChange}
                  >
                    <MenuItem value="">Select Zone</MenuItem>

                    {zonelist.map((zone) => (
                      <MenuItem key={zone.id} value={zone.name}>
                        {zone.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}

              {/* State Dropdown */}
              {/* <Grid item xs={12} sm={6} md={3}>
  <FormControl fullWidth>
    <InputLabel>State</InputLabel>
    <Select
      name="state"
      value={formData.state}
      label="State"
      onChange={(e) => {
        const selectedState = e.target.value;
        setFormData((prev) => ({
          ...prev,
          state: selectedState,
          city: "", // reset city when state changes
        }));
        fetchCities(selectedState);
      }}
    >
      <MenuItem value="">Select State</MenuItem>
      {states.map((state, idx) => (
        <MenuItem key={idx} value={state}>
          {state}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid> */}

              {/* City Dropdown */}
              {/* <Grid item xs={12} sm={6} md={3}>
  <FormControl fullWidth>
    <InputLabel>City</InputLabel>
    <Select
      name="city"
      value={formData.city}
      label="City"
      onChange={handleChange}
      disabled={!formData.state}
    >
      <MenuItem value="">Select City</MenuItem>
      {loadingCities ? (
        <MenuItem disabled>Loading...</MenuItem>
      ) : (
        cities.map((city, idx) => (
          <MenuItem key={idx} value={city.cityName || city}>
            {city.cityName || city}
          </MenuItem>
        ))
      )}
    </Select>
  </FormControl>
</Grid> */}


              {/* <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <InputLabel>Area</InputLabel>
                  <Select
                    name="area"
                    value={formData.area}
                    label="Area"
                    onChange={handleChange}
                  >
                    <MenuItem value="">Select Area</MenuItem>
                    <MenuItem value="Area 1">Area 1</MenuItem>
                    <MenuItem value="Area 2">Area 2</MenuItem>
                  </Select>
                </FormControl>
              </Grid> */}

              {/* <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Post Code"
                  name="postCode"
                  value={formData.postCode}
                  onChange={handleChange}
                />
              </Grid> */}
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion expanded={expanded === 'contact'} onChange={handleAccordionChange('contact')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ContactsIcon color="primary" sx={{ mr: 2 }} />
              <Typography variant="h6">Contact & Tax Information</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Mobile No."
                  name="mobileNo"
                  value={formData.mobileNo}
                  onChange={handleChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        +91
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Phone No."
                  name="phoneNo"
                  value={formData.phoneNo}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Service Tax No."
                  name="serviceTaxNo"
                  value={formData.serviceTaxNo}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Entertainment Tax No."
                  name="entertainmentTaxNo"
                  value={formData.entertainmentTaxNo}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="GST No."
                  name="gstNo"
                  value={formData.gstNo}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="PAN No."
                  name="panNo"
                  value={formData.panNo}
                  onChange={handleChange}
                />
              </Grid>

              

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Aadhar No."
                  name="aadharNo"
                  value={formData.aadharNo}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion expanded={expanded === 'financial'} onChange={handleAccordionChange('financial')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ReceiptIcon color="primary" sx={{ mr: 2 }} />
              <Typography variant="h6">Financial Information</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Credit Limit (in Amount)"
                  name="creditLimit"
                  type="number"
                  value={formData.creditLimit}
                  onChange={handleChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        ₹
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
  <TextField
    select
    fullWidth
    label="Billing Tax Type"
    name="billingTaxId"
    value={formData.billingTaxId}
    onChange={handleChange}
  >
    <MenuItem value="">Select Billing Tax Type</MenuItem>

    {billingTaxTypes.map((item) => (
      <MenuItem key={item.id} value={item.id}>
        {item.name}
      </MenuItem>
    ))}
  </TextField>
</Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Online Recharge Minimum Amount"
                  name="onlineRechargeMinAmount"
                  type="number"
                  value={formData.onlineRechargeMinAmount}
                  onChange={handleChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        ₹
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Business Name"
                  name="businessName"
                  value={formData.businessName}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                   type="number"
                   label="Subscription Extended Days"
                    name="subscriptionExtendedDays"
                   value={formData.subscriptionExtendedDays}
                  onChange={handleChange}
                  />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion expanded={expanded === 'logo'} onChange={handleAccordionChange('logo')}>
  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <ImageIcon color="primary" sx={{ mr: 2 }} />
      <Typography variant="h6">Logo</Typography>
    </Box>
  </AccordionSummary>

  <AccordionDetails>
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 3, textAlign: 'center' }}>

          {existingLogo ? (
            <Avatar
              src={ existingLogo }
              sx={{ width: 140, height: 140, mx: 'auto', mb: 2 }}
            />
          ) : (
            <Avatar sx={{ width: 140, height: 140, mx: 'auto', mb: 2 }}>
              <ImageIcon />
            </Avatar>
          )}

          <Button
            component="label"
            variant="contained"
            startIcon={<CloudUploadIcon />}
          >
            Upload Logo
            <input
              type="file"
              hidden
              accept="image/*"
              onChange={handleFileChange}
            />
          </Button>

        </Paper>
      </Grid>
    </Grid>
  </AccordionDetails>
</Accordion>

        <Accordion expanded={expanded === 'settings'} onChange={handleAccordionChange('settings')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <SettingsIcon color="primary" sx={{ mr: 2 }} />
              <Typography variant="h6">Franchisee Settings</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <InputLabel>Franchisee Package PriceList*</InputLabel>
                  <Select
                    name="priceListId"
                    value={formData.priceListId}
                    label="Franchisee PriceList*"
                    onChange={handleChange}
                  // disabled={priceLists.length === 0}
                  >
                    <MenuItem value="">Select Price List</MenuItem>
                    {priceLists.map((p) => (
                      <MenuItem key={p.id} value={p.id}>
                        {p.areaName} - {p.locationName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControlLabel
                  control={
                    <Switch
                      name="disablePostPaidCustomerCreation"
                      checked={formData.disablePostPaidCustomerCreation}
                      onChange={handleSwitchChange}
                      color="primary"
                    />
                  }
                  label="Disable PostPaid Customer Creation"
                  labelPlacement="start"
                  sx={{ justifyContent: 'space-between', ml: 0, width: '100%' }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControlLabel
                  control={
                    <Switch
                      name="isApplyFranchiseeInfoInBill"
                      checked={formData.isApplyFranchiseeInfoInBill}
                      onChange={handleSwitchChange}
                      color="primary"
                    />
                  }
                  label="Apply Franchisee Info In Bill"
                  labelPlacement="start"
                  sx={{ justifyContent: 'space-between', ml: 0, width: '100%' }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControlLabel
                  control={
                    <Switch
                      name="isManageUserWallet"
                      checked={formData.isManageUserWallet}
                      onChange={handleSwitchChange}
                      color="primary"
                    />
                  }
                  label="Manage User Wallet"
                  labelPlacement="start"
                  sx={{ justifyContent: 'space-between', ml: 0, width: '100%' }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
  <FormControlLabel
    control={
      <Switch
        name="isManageLCOWallet"
        checked={formData.isManageLCOWallet}
        onChange={handleSwitchChange}
        color="primary"
      />
    }
    label="Manage LCO Wallet"
    labelPlacement="start"
    sx={{ justifyContent: 'space-between', ml: 0, width: '100%' }}
  />
</Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControlLabel
                  control={
                    <Switch
                      name="disableSubTypeDay"
                      checked={formData.disableSubTypeDay}
                      onChange={handleSwitchChange}
                      color="primary"
                    />
                  }
                  label="Disable SubType Day"
                  labelPlacement="start"
                  sx={{ justifyContent: 'space-between', ml: 0, width: '100%' }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControlLabel
                  control={
                    <Switch
                      name="disableSubTypeOption"
                      checked={formData.disableSubTypeOption}
                      onChange={handleSwitchChange}
                      color="primary"
                    />
                  }
                  label="Disable SubType Option"
                  labelPlacement="start"
                  sx={{ justifyContent: 'space-between', ml: 0, width: '100%' }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        {/* <Accordion expanded={expanded === 'logo'} onChange={handleAccordionChange('logo')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ImageIcon color="primary" sx={{ mr: 2 }} />
              <Typography variant="h6">Logo & Branding</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Paper variant="outlined" sx={{ p: 3, textAlign: 'center' }}>
                  <Typography variant="subtitle1" gutterBottom>
                    Upload Franchisee Logo
                  </Typography>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    Best Size (250 × 250) PNG/JPG
                  </Typography>
                  
                  <Box sx={{ mt: 2, mb: 2 }}>
                    {formData.logo ? (
                      <Avatar 
                        src={typeof formData.logo === 'string' && !formData.logo.startsWith('data:') ? 
                          `/${formData.logo}` : formData.logo} 
                        sx={{ width: 150, height: 150, mx: 'auto' }}
                      />
                    ) : (
                      <Avatar sx={{ width: 150, height: 150, mx: 'auto', bgcolor: 'grey.200' }}>
                        <ImageIcon sx={{ fontSize: 60, color: 'grey.500' }} />
                      </Avatar>
                    )}
                  </Box>
                  
                  <Button
                    component="label"
                    variant="contained"
                    startIcon={<CloudUploadIcon />}
                    sx={{ mr: 2 }}
                  >
                    Upload Logo
                    <input
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                  </Button>
                  
                  {formData.logo && (
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => setFormData(prev => ({ ...prev, logo: null }))}
                    >
                      Remove
                    </Button>
                  )}
                </Paper>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" color="text.secondary" paragraph>
                  <strong>Note:</strong> A high-quality logo helps establish your brand identity. 
                  For best results, upload a square image with transparent background.
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  Supported formats: PNG, JPG, JPEG (Max 2MB)
                </Typography>
                {typeof formData.logo === 'string' && !formData.logo.startsWith('data:') && (
                  <Typography variant="body2" sx={{ mt: 2 }}>
                    Current logo path: {formData.logo}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion> */}
      </Paper>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Button
          variant="outlined"
          color="secondary"
          startIcon={<CancelIcon />}
          sx={{ mr: 2 }}
          onClick={() => navigate('/franchise')}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          startIcon={<CheckCircleIcon />}
        >
          Update Franchisee
        </Button>
      </Box>
    </Box>
  );
};

export default EditFranchisee;